module.exports = "button {\n    margin-left: 192px;\n}\n.error {\n    margin-left: 192px;\n}\n.upto {\n    margin-top: 10px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/new-cash-out/new-cash-out.component.css
// module id = ./src/app/new-cash-out/new-cash-out.component.css
// module chunks = main